import { addToast } from "@heroui/react";
import { CheckCircleCreatorIc, CheckCirclePartnerIc, ErrorCircleIc} from "../components/icons";

// Успех для партнера - синяя иконка
export const showPartnerSuccess = (message: string) => {
  const isPartner = window.location.pathname.startsWith('/partner');

  addToast({
    description: message,
    // color: "primary",
    icon: <CheckCirclePartnerIc/>,
    timeout: 3000,
  });
};

// Успех для креатора - фиолетовая иконка
export const showCreatorSuccess = (message: string) => {
  const isPartner = window.location.pathname.startsWith('/partner');
  addToast({
    description: message,
    // col<CheckCirclePartnerIc/>,
    timeout: 3000,
  });
};

// Ошибка - красная иконка
export const showError = (message: string) => {
  addToast({
    description: message,
    // color: "danger",
    icon: <ErrorCircleIc  />,
    timeout: 5000,
  });
};
